import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
/* eslint-disable react-hooks/exhaustive-deps */
import Box from "@mui/material/Box";
import FdTypography from "../UIComponents/Typography/FdTypography";
import { useForm, Controller } from "react-hook-form";
import FdButton from "../UIComponents/Button/FdButton";
import { alertForm as classes } from "../Alert/styles";
import FdTextField from "../UIComponents/TextField/FdTextfield";
import RouteLeavingGuard from "../RouteLeavingGuard/RouteLeavingGuard";
import NotificationMessage, {
  notificationType,
} from "../NotificationMessage/NotificationMessage";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import { InputAdornment } from "@mui/material";

const API_URL = "https://api-fr.devthree.fielddrivedev.com";

// interface IMicroProps{
//   subdomain:string,
//   primaryColor: string,
//   secondaryColor: string,
//   bannerImageUrl: string,
//   customerTag: string,
//   website: string,
// }
const MicroSite = () => {
  let navigate = useNavigate();

  const { eventId } = useParams() as any;
  const [microSiteData, setMicroSiteData] = useState<any>({});
  const notificationRef = useRef<any>();
  const convertToHex = (color: number) => {
    const hex = color.toString(16).padStart(6, "0");
    return hex;
  };
  const convertToDecimal = (color: string) => {
    const decimal = parseInt(color, 16);
    return decimal;
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch(`${API_URL}/event/${eventId}`);
      const data = await response.json();
      setMicroSiteData(data);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };

  const createMicroSite = async (values: any) => {
    const primaryColorToApi: any = convertToDecimal(
      String(values.primaryColor)
    );
    const post = { ...values, primaryColor: primaryColorToApi };
    const response = await fetch(`${API_URL}/event/${eventId}`, {
      method: microSiteData ? "PUT" : "POST",
      body: JSON.stringify(post),
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (microSiteData) {
      notificationRef.current?.show(
        "Fields updated successfully",
        notificationType.Success
      );
    } else {
      notificationRef.current?.show(
        "Fields Added successfully",
        notificationType.Success
      );
    }
  };
  const onSubmit = async (data: any) => {
    await createMicroSite(data);
  };

  const initialValues = {
    subdomain: microSiteData.subdomain || "",
    primaryColor: microSiteData.primaryColor === 0 ? "" : convertToHex(Number(microSiteData.primaryColor)) || "",
    secondaryColor: microSiteData.secondaryColor || 0,
    bannerImageUrl: microSiteData.bannerImageUrl || "",
    customerTag: microSiteData.customerTag || "",
    website: microSiteData.website || "",
  };
  const {
    register,
    handleSubmit,
    formState: { isDirty, errors },
    watch,
    reset,
    control,
  } = useForm({
    defaultValues: initialValues,
  });


  useEffect(() => {
    reset(initialValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [microSiteData, reset]);

  return (
    <div>
      <>
        <Box sx={[classes.root, { width: "100%" }]}>
          <Box sx={classes.infoTitle}>
            <Box textAlign="left">
              <FdTypography
                label={"Microsite"}
                variant="h2"
                component="h2"
                sx={{ marginBottom: "10px" }}
              />
            </Box>
          </Box>
          <Box
            sx={[
              classes.infoFields,
              { height: "calc(100vh - 240px)", overflow: "auto" },
            ]}
          >
            <form
              id="micrositeForm"
              onSubmit={handleSubmit(onSubmit)}
              noValidate
              style={{ width: "100%", textAlign: "left" }}
            >
              <Box sx={classes.formRoot}>
                <Box marginBottom="15px" textAlign={"right"}>
                  <Controller
                    name="secondaryColor"
                    control={control}
                    render={({ field }) => (
                      <FormControlLabel
                        label="Active"
                        labelPlacement="start"
                        control={
                          <Switch
                            {...field}
                            checked={Boolean(field.value)}
                            onChange={(e) => {
                              field.onChange(e.target.checked ? 1 : 0);
                              handleSubmit(onSubmit)();
                            }}
                          />
                        }
                      />
                    )}
                  />
                </Box>
                {watch("secondaryColor") === 1 ? (
                  <>
                    <Box marginBottom="15px">
                      <FdTextField
                        register={register}
                        name="subdomain"
                        label="Sub domain"
                        placeholder="www.google.com"
                      />
                    </Box>

                    <Box marginBottom="15px">
                      <FdTextField
                        register={register}
                        name="primaryColor"
                        label="Primary Color"
                        placeholder="0b8ce9"
                        required
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">#</InputAdornment>
                          ),
                        }}
                        error={errors.primaryColor?.type === "required"}
                        errorMsg={
                          errors.primaryColor?.type &&
                          "Primary color is Required"
                        }
                      />
                    </Box>
                    <Box marginBottom="15px">
                      <FdTextField
                        register={register}
                        name="bannerImageUrl"
                        label="Banner Image Url"
                        placeholder="www.image-name.png"
                        required
                        error={errors.bannerImageUrl?.type === "required"}
                        errorMsg={
                          errors.bannerImageUrl?.type && "Banner is Required"
                        }
                      />
                    </Box>
                    <Box marginBottom="15px">
                      <FdTextField
                        register={register}
                        name="customerTag"
                        label="Customer Tag"
                        required
                        error={errors.customerTag?.type === "required"}
                        errorMsg={
                          errors.customerTag?.type && "Customer tag is Required"
                        }
                      />
                    </Box>
                    <Box marginBottom="15px">
                      <FdTextField
                        register={register}
                        name="website"
                        label="Website"
                        placeholder="www.google.com"
                        required
                        error={errors.website?.type === "required"}
                        errorMsg={
                          errors.website?.type && "Website Url is Required"
                        }
                      />
                    </Box>
                  </>
                ) : (
                  <></>
                )}
              </Box>
            </form>
            <RouteLeavingGuard
              when={isDirty}
              navigate={(path) => navigate(path)}
              shouldBlockNavigation={(location) => isDirty}
            />
            <NotificationMessage ref={notificationRef} />
          </Box>
          {watch("secondaryColor") === 1 ? (
            <FdButton
              sx={classes.saveButton}
              form="micrositeForm"
              type="submit"
              ButtonName="Save"
            />
          ) : (
            <></>
          )}
        </Box>
      </>
    </div>
  );
};

export default MicroSite;
